import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.iterator";
import "antd/lib/config-provider/style";
import _ConfigProvider from "antd/lib/config-provider";
import "antd/lib/select/style";
import _Select from "antd/lib/select";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import intl from 'react-intl-universal';
import { find } from 'lodash';
import styles from './index.scss';
import { useOnMount } from '@utils/hooks';
import { setCookie } from '@utils/index';
import { COOKIE_KEYS } from '@constants/index';
import PageLoading from '@components/PageLoading';
import { SUPPOER_LOCALES, LOCALES_KEYS, getLocaleLoader } from '@locales/loader';

var IntlWrapper = (_ref) => {
  var children = _ref.children;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      currentLocale = _useState2[0],
      setCurrentLocale = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      antdLocaleData = _useState4[0],
      setAntdLocaleData = _useState4[1];

  function loadLocales() {
    var targetLocale = intl.determineLocale({
      cookieLocaleKey: COOKIE_KEYS.LANG
    }); // default is English

    if (!find(SUPPOER_LOCALES, {
      value: targetLocale
    })) {
      targetLocale = LOCALES_KEYS.EN_US;
    }

    getLocaleLoader(targetLocale).then(res => {
      intl.init({
        currentLocale: targetLocale,
        locales: {
          [targetLocale]: res.localeData
        }
      }).then(() => {
        setCurrentLocale(targetLocale);
        setAntdLocaleData(res.antdLocaleData);
      });
    });
  }

  function onSelectLocale(val) {
    setCookie(COOKIE_KEYS.LANG, val);
    location.reload();
  }

  useOnMount(loadLocales);

  if (!currentLocale) {
    return /*#__PURE__*/React.createElement(PageLoading, null);
  }

  var selectLanguage = /*#__PURE__*/React.createElement(_Select, {
    className: styles.intlSelect,
    onChange: onSelectLocale,
    value: currentLocale
  }, SUPPOER_LOCALES.map(l => /*#__PURE__*/React.createElement(_Select.Option, {
    key: l.value,
    value: l.value
  }, l.name)));
  return /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: antdLocaleData,
    direction: "rtl"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, selectLanguage, children));
};

export default IntlWrapper;